import { DATATABLE_EXPORT } from "../../../../Config/ApiUrl";
import * as actions from "../../../../Config/ApiUrl";

export const StudentListWithCourseSchema = {
	components: { },

	data() {

		return {
			DATATABLE_EXPORT,
			isStudentProfileModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: "/transaction/getStudentListWithCourse?course_id="+this.CourseId,
			tableId: "student-list-With-course-table",
			formId: "student-list-With-course",
			rowData: {},
			tableColumns: [
				{
					title: "Student Id",
					type: "custom-html",
					key: "student_id",
					modifier: (value, row) => {
						const studentId =
							row.student_id ||
							row.lead_id_number ||
							row.clc_id_number ||
							'-';

						return `<a onclick="window.handleProfileStudent(${row.id})"
									style="color: blue;cursor: pointer;">
									${studentId}
								</a>`;
					}
				},
				{
					title: "Student Name",
					type: "custom-html",
					key: "full_name",
					modifier: (value, row) => {
						return `<a onclick="window.handleProfileStudent(${row.id})"
									style="color: blue;cursor: pointer;">
									${row.full_name || '-'}
								</a>`;
					}
				},
				{
					title: "Date Of Birth",
					type: "text",
					key: "date_of_birth",
				},
				{
					title: "School Name",
					type: "custom-html",
					key: "school",
					modifier: (value,row) => {
						if (!value) return "-";

						if (value.name === "Others") {
							return `Others (${row.school_name_other ?? "-"})`;
						}

						return value.name ?? "-";
					},
				},
				{
					title: "School Level",
					type: "custom-html",
					key: "school_level",
					modifier: (value) => {
						return value?.name ?? "-";
					},
				},
				{
					title: "Product Name",
					type: "text",
					key: "product_name"
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "StudentListWithCourseTable",
				url: "/transaction/getStudentListWithCourse?course_id="+this.CourseId,
				showHeader: true,
				enableHighlights: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					// {
				],
				filters: [
					
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isPifDisabled(rowData) {
			if (rowData.status === "inactive") return true;
			else if (rowData.status === "not_interested") return true;
			else if (rowData.status === "invalid") return true;
			else return false;
		},
	},
};
